module.exports = __webpack_public_path__ + "static/media/adjust.42916e7c.svg";